export
const name: string = "ShadowMapVariance16CutOff";

export
const preproc: string = `
    #ifdef WEBGL2
    #else
    #extension GL_OES_standard_derivatives : enable
    #endif

    //precision mediump float;
`;

export
const declaration: string = `
    uniform mat4 u_lightViewMatrix;
    uniform float u_lightMaxLength;
    uniform sampler2D u_heightTexture;
`;

export
const varyings: string = `
    varying vec3 v_worldNormal;
    varying vec4 v_worldPosition;
    varying float v_visible;
    varying vec4    v_relativePosition;
`;

export
const implementation: string = `
    void main() {
        if (v_visible < 0.5) {
            discard;
        }

    #ifdef CLIPPING_PLANE
        resolveClippingPlane();
    #endif

        // Resolve height
        vec2 relative = v_relativePosition.xy / v_relativePosition.w * 0.5 + 0.5;
        vec4 heightData = texture2D(u_heightTexture, relative);

        // Test if any data was written
        if (heightData.x < 1.0 && heightData.y < 1.0 && heightData.z < 1.0 && heightData.w < 1.0) {
            float height = - vec4ToFloat(heightData);
            if (v_relativePosition.z / v_relativePosition.w >= height) {
                discard;
            }
        }

        vec3 worldNormal = normalize(v_worldNormal);
        vec4 lightPos = u_lightViewMatrix * v_worldPosition;
        vec3 lightPosition = lightPos.xyz / lightPos.w;
        float depth = clamp(length(lightPosition) / u_lightMaxLength, 0.0, 1.0);
        float dx = dFdx(depth);
        float dy = dFdy(depth);

        vec2 a = packFloat(depth);
        vec2 b = packFloat(pow(depth, 2.0) + 0.25 * (dx*dx + dy*dy));
        gl_FragColor = vec4(a, b);

    #ifdef LOGDEPTH
        resolveLogarithmicDepth();
    #endif
    }
`;
